import Filter from "../../../../models/Filter";

function getFilters() {
  return [
    new Filter({
      label: "Ensembl",
      key: "ensembl",
      totalCount: 0,
      isVisible: 1,
      category: "DBs",
    }),
    new Filter({
      label: "RefSeq",
      key: "refSeq",
      totalCount: 0,
      isVisible: 1,
      category: "DBs",
    }),
    new Filter({
      label: "MANE select",
      key: "maneSelect",
      isVisible: 1,
      category: "transcript",
      totalCount: 0,
    }),
    new Filter({
      label: "Canonical",
      key: "canonical",
      isVisible: 1,
      category: "transcript",
      totalCount: 0,
    }),
    new Filter({
      label: "No sensitivity evidence",
      key: "normal",
      totalCount: 0,
      isVisible: 0,
      category: "Dosage Sensitivity",
    }),
    new Filter({
      label: "Haploinsufficiency",
      key: "haplo",
      totalCount: 0,
      isVisible: 0,
      category: "Dosage Sensitivity",
    }),
    new Filter({
      label: "Triplosensitivity",
      key: "triplo",
      totalCount: 0,
      isVisible: 0,
      category: "Dosage Sensitivity",
    }),
    new Filter({
      label: "Haploinsufficiency & Triplosensitivity",
      key: "haploTriplo",
      totalCount: 0,
      isVisible: 0,
      category: "Dosage Sensitivity",
    }),
    new Filter({
      label: "Max Rows Limit",
      key: "maxrows",
      defaultVal: 3,
      min: 1,
      max: 200,
      totalCount: null,
      isVisible: true,
      value: 3,
      type: "number",
    }),
  ];
}
export default getFilters;
